const getCdnUrl = (cdnPath: string) => {
  const cdnURL = import.meta.env.VITE_REACT_APP_SHARED_IMAGE_PATH

  if (!cdnURL) {
    // TODO: log error with missing details when proper logging implemented
    // eslint-disable-next-line no-console
    console.warn('Missing VITE_REACT_APP_SHARED_IMAGE_PATH in .env file')
    return ''
  }

  return `${cdnURL}/${cdnPath}`
}

export { getCdnUrl }
